import React from 'react'
import styled from 'styled-components';
const BonusHeader = ({ title, subTitle, icon }: { title: string; subTitle: string; icon }) => {
	return (
		<Wrapper>
			<IconWrapper>
				{icon}
				<Title>{title}</Title>
			</IconWrapper>
			<SubTitle>{subTitle}</SubTitle>
		</Wrapper>
	);
};
const SubTitle = styled.span({
	fontSize: 9,
});
const Title = styled.span({
	fontSize: 14,
	fontWeight: 'bold',
	marginLeft: 10,
});
const IconWrapper = styled.div({
	flexDirection: 'row',
	alignItems: 'center',
	marginBottom: 5,
	display: 'flex',
});
const Wrapper = styled.div(({ theme }) => ({
	flexDirection: 'column',
	paddingTop: 12,
	marginBottom: 10,
	display: 'flex',
	color: theme.colors.darkR,
}));
export default BonusHeader;
